import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// CRA dev-overlay safety: Razorpay's checkout iframe is cross-origin and
// React DevTools internals walk window properties on it, throwing
// SecurityError. The error is harmless and does not exist in the
// production build. We swallow it so the red overlay does not show.
if (typeof window !== "undefined") {
  const isCrossOriginFrameError = (msg) =>
    typeof msg === "string" &&
    (msg.includes("cross-origin frame") ||
      msg.includes("Blocked a frame with origin"));

  window.addEventListener(
    "error",
    (event) => {
      if (isCrossOriginFrameError(event?.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    if (
      reason instanceof Error &&
      isCrossOriginFrameError(reason.message)
    ) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
